<template>
  <span
    class="flex relative items-center select-none"
    @mouseenter="dataIsHovered = true"
    @mouseleave="dataIsHovered = false"
    >
    <span
      v-if="user.firstname"
      class="hidden md:inline-block font-semibold truncate max-w-[200px] pl-4"
      v-text="t('greeting')+', '+ user.firstname"
      />

    <ui-navigation-profile-avatar
      @click="dataShowFlyout = !dataShowFlyout"
      />

    <div v-show="dataShowFlyout" class="ui-flyout">
      <div class="min-w-[200px]">
        <span v-text="user.email" />
        <hr>
        <ui-link to="/profile" :text="t('Profile')"/>
        <ui-link to="/home/settings/account" :text="t('Settings')"/>
        <hr>
        <ui-link class="text-red-400 hover:text-red-600" :text="t('Logout')" @click="logout"/>
      </div>
    </div>
  </span>
</template>

<script setup lang="ts">
const dataShowFlyout = ref(false)
const dataIsHovered = ref(false)
const dataLastHoverStart = ref(0)

const { t } = useI18n({
  messages: {
    en:{
      greeting: 'Hello',
      'Profile': 'Profile',
      'Settings': 'Settings',
      'Logout': 'Logout'
    },
    de: {
      greeting: 'Hallo',
      'Profile': 'Profil',
      'Settings': 'Einstellungen',
      'Logout': 'Ausloggen'
    },
    at: {
      greeting: 'Servus'
    },
    es: {
      greeting: 'Hola',
      'Profile': 'Perfil',
      'Settings': 'Ajustes',
      'Logout': 'Cerrar sesión'
    },
    uk: {
      greeting: 'Привіт',
      'Profile': 'Профіль',
      'Settings': 'Налаштування',
      'Logout': 'Вийти'
    }
  } as any
})

watch(dataIsHovered, (val) => {
  dataLastHoverStart.value = Date.now()

  if (!val) {
    setTimeout(() => {
      const start = dataLastHoverStart.value
      if (start == dataLastHoverStart.value && !dataIsHovered.value) {
        dataShowFlyout.value = false
      }
    }, 1000)
  }
})

watch(() => useRoute().fullPath, () => {
  dataShowFlyout.value = false
})
</script>
